import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, message, Upload, UploadProps, Col, Row, Modal } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { MessageType } from 'models/MessageType';
import { hasUploadedFile } from 'components/form';
import { RcFile } from 'antd/es/upload';
import uploudlistIcon from 'assets/images/support/uploudlist.svg';
import image from 'assets/images/Image file.svg';
// import { reject } from 'lodash';

const TEN_MB = 10 * 1024 * 1024;
const MAX_PER_FILE_SIZE = TEN_MB;
const MAX_SIZE = TEN_MB * 10;
const MAX_NUMBER_OF_ATTACHMENTS = 12;
type DocumentsCardType = {
  setInvalid: (invalid: boolean) => void;
};
export const DocumentsCard = ({ setInvalid }: DocumentsCardType) => {
  const { t } = useTranslation();
  const [exceedNo, setExceedNo] = useState(false);
  const [exceedSize, setExceedSize] = useState(false);
  const [attachments, setAttachments] = useState<UploadFile[]>([]);
  useEffect(() => {
    setInvalid(exceedSize || exceedNo);
  }, [exceedNo, exceedSize, setInvalid]);

  const attachmentUploadProps: UploadProps = useMemo(
    () => ({
      fileList: attachments,
      listType: 'picture',
      multiple: false,
      accept: '.png,.jpg,.pdf,.zip,.doc,.docx,.xls,.xlsx,.txt,.*',
      onChange: ({ fileList }) => {
        const totalSize = fileList.map((a) => a.size || 0).reduce((acc, cur) => acc + cur, 0);
        setExceedSize(totalSize > MAX_SIZE);
        setExceedNo(fileList.length > MAX_NUMBER_OF_ATTACHMENTS);
        setAttachments(fileList);
      },
      onRemove: () => {
        return new Promise((resolve) => {
          Modal.confirm({
            title: '',
            icon: '',
            width: 510,
            centered: true,
            className: 'Modalconfirm',
            okText: `${t('life.enquiry.Cancel')}`,
            cancelText: `${t('life.enquiry.delete')}`,
            content: `${t('life.enquiry.sureToDelete')}`,
            onOk: () => {
              return false;
            },
            onCancel: () => {
              return resolve(true);
            },
          });
        });
      },

      beforeUpload: (f) => {
        if (hasUploadedFile(attachments as RcFile[], f)) {
          message[MessageType.ERROR](t('common.error.notAllowUploadSameDocument'));
          return Upload.LIST_IGNORE;
        }

        if (f.size > MAX_PER_FILE_SIZE) {
          message[MessageType.ERROR](t('common.error.sizeExceeds', { amount: 10 }));
          return Upload.LIST_IGNORE;
        }
        return false;
      },
    }),
    [attachments, t],
  );

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          name="attachments"
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.enquiry.Supplementary')}
            </span>
          }
        >
          <Upload
            className="customUpload"
            name="documents"
            maxCount={5}
            {...attachmentUploadProps}
            iconRender={() => <img src={image} width={24} height={24} alt="upload list icon" />}
          >
            <div className="buttoncontent">
              {attachments.length < 12 && (
                <Button className="button" disabled={attachments.length == 5}>
                  {t('enquiry.upload')}
                </Button>
              )}
            </div>
            <div
              style={{
                color: '#B0B2B3',
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                marginTop: '20px',
              }}
            >
              <img src={uploudlistIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
              {t('life.enquiry.uploadedAttr')}
            </div>
          </Upload>
        </BoldLabelFormItem>
      </Col>
    </Row>
  );
};
